import palette from '../palette';

const muiLinearProgressOverrides = {
  styleOverrides: {
    root: {
      borderRadius: '3px',
      overflow: 'hidden',
    },
    colorPrimary: {
      backgroundColor: palette.common.neutral,
    },
  },
};

export default muiLinearProgressOverrides;
